import { Component, Input } from '@angular/core';

export type InstitutionalSignatureVariant = 'light' | 'dark';
export type InstitutionalSignatureLayout = 'header' | 'footer' | 'compact';

@Component({
  selector: 'app-institutional-signature',
  standalone: true,
  styleUrl: './institutional-signature.component.scss',
  template: `
    <div
      class="institutional-signature-bar"
      [class.institutional-signature-bar--dark]="variant === 'dark'"
      [class.institutional-signature-bar--compact]="layout === 'compact'"
      [class.institutional-signature-bar--footer]="layout === 'footer'"
      role="img"
      [attr.aria-label]="ariaLabel"
    >
      @if (layout === 'footer') {
        <div class="institutional-signature-bar__trail">
          <!-- <img
            class="sig-agora-especialistas"
            src="/imgs/identidade/agora-tem-especialistas.png"
            alt=""
            aria-hidden="true"
            width="280"
            height="80"
          /> -->
          <img
            class="sig-agsus"
            [src]="agsusLogoSrc"
            alt=""
            aria-hidden="true"
            width="358"
            height="109"
          />
          <img
            class="sig-ms-gov"
            [src]="govSignatureSrc"
            alt=""
            aria-hidden="true"
            width="520"
            height="95"
          />
        </div>
      } @else {
        <img
          class="sig-gov-stack"
          [src]="govSignatureSrc"
          alt=""
          aria-hidden="true"
          width="520"
          height="95"
        />
      }
    </div>
  `,
})
export class InstitutionalSignatureComponent {
  @Input() variant: InstitutionalSignatureVariant = 'light';
  @Input() layout: InstitutionalSignatureLayout = 'header';

  get ariaLabel(): string {
    if (this.layout === 'footer') {
      return 'Campanha Agora tem Especialistas, Agência Saúde Digital AgSUS, Ministério da Saúde e Governo Federal do Brasil';
    }
    return 'SUS, Ministério da Saúde e Governo Federal do Brasil';
  }

  get agsusLogoSrc(): string {
    return '/imgs/identidade/logo-agsus-utic-monocromatica.png';
  }

  get govSignatureSrc(): string {
    return this.variant === 'dark'
      ? '/imgs/identidade/assinatura-ms-gov-horizontal-negativa.png'
      : '/imgs/identidade/assinatura-ms-gov-horizontal-colorida.png';
  }
}
